module.exports = require('../_components/@alicd/next-balloon/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/balloon/index.js
// module id = 74
// module chunks = 0